/***********************************
    // Menu Style Color
    // black, white, teal, purple
***********************************/
const menuStyle = "transparent";


/***********************************
    // Menu Type
    // dark, light, colored
***********************************/
const menuType = "light";



/***********************************
    // Top Bar Style Color
    // black, white, teal, purple
***********************************/
const topbarStyle = "transparent";


/***********************************
    // Top bar Type
    // dark, light, colored
***********************************/
const topbarType = "light";

/***********************************
    // Navigation Width
    // default, mini
***********************************/
const navWidth = "default";

/***********************************
    // Chat Type
    // overlap, squeeze
***********************************/
const chatType = "overlap";

/***********************************
    // Chat Width
    // closed, open
***********************************/
const chatWidth = "closed";

 // mini


export {
    menuStyle,
    topbarStyle,
    menuType,
    topbarType,
    navWidth,
    chatWidth,
    chatType,
};
